import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";
import { Platform } from "react-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  container: {
    padding: 0,
  },
  productAndDate: createResponsiveStyles({
    base: {
      display: "flex",
      flexDirection: "column",
    },
    medium: {
      flexDirection: "row",
      flexWrap: "wrap",
    },
  }),
  collectionDate: createResponsiveStyles({
    large: {
      paddingHorizontal: theme.spacing.xlarge2,
    },
  }),
  panel: createResponsiveStyles({
    base: {
      overflow: "visible",
    },
    large: {
      height: 390,
      justifyContent: "flex-start",
    },
  }),
  productDate: createResponsiveStyles({
    base: {
      color: theme.colors.brand.base,
      textAlign: "center",
    },
    medium: {
      textAlign: "left",
    },
  }),
  productDetails: createResponsiveStyles({
    base: {
      alignItems: "center",
    },
    small: {
      flex: 1,
      alignItems: "flex-start",
    },
  }),
  productDetailsContainer: createResponsiveStyles({
    base: {
      alignItems: "center",
    },
    medium: {
      marginTop: theme.spacing.small,
      flexDirection: "row",
    },
  }),
  priceContainer: createResponsiveStyles({
    base: {
      marginTop: theme.spacing.small,
      alignItems: "center",
    },
    small: {
      alignItems: "baseline",
    },
  }),
  priceInnerContainer: {
    flexDirection: "row",
    alignItems: "baseline",
  },
  imageContainer: createResponsiveStyles({
    base: {
      width: 200,
      height: 200,
      alignSelf: "center",
    },
    small: {
      display: "flex",
      flex: 1,
      width: "100%",
      height: 260,
      alignSelf: "flex-start",
    },
  }),
  image: {
    width: "100%",
    height: "100%",
  },
  productTitle: createResponsiveStyles({
    base: {
      marginBottom: theme.spacing.xsmall2,
      textAlign: "center",
    },
    small: {
      textAlign: "left",
    },
  }),
  productDescription: createResponsiveStyles({
    base: {
      textAlign: "center",
    },
    small: {
      textAlign: "left",
    },
  }),
  calloutChargePanel: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: theme.spacing.xsmall2,
    paddingHorizontal: theme.spacing.xsmall,
  },
  imagePanelWrapper: createResponsiveStyles({
    base: {
      marginTop: theme.spacing.small,
      alignItems: "center",
    },
    small: {
      alignItems: "flex-start",
    },
  }),
  inputImage: {
    padding: theme.spacing.medium,
    borderRadius: theme.spacing.xsmall,

    width: 260,
    height: 110,

    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  photoExplanation: createResponsiveStyles({
    base: {
      marginTop: theme.spacing.small,
      textAlign: "center",
    },
    small: {
      textAlign: "left",
    },
  }),
  formWrapper: createResponsiveStyles({
    medium: {
      marginTop: theme.spacing.small,
      flexDirection: "row",
    },
  }),
  heading: {
    marginBottom: theme.spacing.medium,
    fontFamily: "ProximaBold",
  },
  modalButtonsContainer: createResponsiveStyles({
    base: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: theme.spacing.xsmall2,
      marginTop: theme.spacing.small,
    },
    small: {
      marginTop: theme.spacing.medium,
      marginBottom: theme.spacing.small,
      flexDirection: "row",
    },
  }),

  modalCheckoutButtonWrapper: createResponsiveStyles({
    base: {
      marginBottom: theme.spacing.small,
    },
    small: {
      marginBottom: 0,
      marginRight: theme.spacing.xlarge2,
    },
  }),
  modalImageWrap: {
    width: 150,
    height: 150,
  },
  modalHeading: {
    textAlign: "center",
    fontFamily: "ProximaBold",
    marginTop: theme.spacing.xsmall2,
  },
  label: {
    color: theme.colors.light.base,
  },
  error: Platform.select({
    web: {
      position: "absolute",
      bottom: -29,
    },
    default: {
      marginBottom: -theme.spacing.xsmall,
    },
  }),
  dateError: {
    position: "absolute",
    top: 300,
    right: theme.spacing.xsmall,
  },
  timeslotError: {
    position: "absolute",
    bottom: -30,
    right: theme.spacing.xsmall,
  },
  deliveryOption: {
    paddingRight: theme.spacing.xsmall,
  },
  productDetailsWrapper: createResponsiveStyles({
    small: {
      flexDirection: "row",
    },
  }),
  prohibitedItem: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginHorizontal: theme.spacing.medium,
    marginBottom: theme.spacing.xsmall,
  },
  selectedProhibitedItem: {
    backgroundColor: theme.colors.negative.base,
    marginHorizontal: 0,
    paddingHorizontal: theme.spacing.medium,
  },
  prohibitedIcon: {
    backgroundColor: theme.colors.negative.base,
    borderRadius: theme.spacing.xlarge,
    marginTop: 2,
    marginRight: theme.spacing.xsmall,
    padding: theme.spacing.xsmall2,
    marginLeft: theme.spacing.xsmall2,
  },
  selectedProhibitedIcon: {
    backgroundColor: theme.colors.light.base,
  },
  overlay: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: `${theme.colors.dark.base}AA`,
    zIndex: 1,
  },
  wasteDescription: {
    marginBottom: 0,
    zIndex: 1,
  },
  wasteDescriptionInput: {
    height: theme.spacing.xlarge4,
    textAlignVertical: "top",
  },
  basketError: createResponsiveStyles({
    base: {
      backgroundColor: theme.colors.negative.base,
      alignSelf: "center",
    },
    small: {
      alignSelf: "flex-end",
      position: "absolute",
      marginTop: theme.spacing.small,
    },
  }),
  prohibitedItemsHeading: {
    marginHorizontal: theme.spacing.medium,
    marginTop: theme.spacing.xlarge,
    marginBottom: theme.spacing.small,
  },
  contactUsPanel: {
    backgroundColor: theme.colors.greyscale.dark,
    marginTop: theme.spacing.medium,
    padding: theme.spacing.medium,
  },
});
